// extracted by mini-css-extract-plugin
export default {"text":"text_text__Lroy7","white":"text_white__j8psX","lighter":"text_lighter__KQGMV","light":"text_light__RqhRX","dark":"text_dark__Sqvpy","accent":"text_accent__Sn45y"};